import { createMuiTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

/* 
    @objects
    > overrides: Changes default style injected by Material-UI into the DOM

    > ascents: Specially for dynamic input , buttons for optimization.

    > palette: Color scheme in whole app. Reference from EO2V2_Specifications

    > typography: Styles for all texts in h1,button etc.
*/
const KEYS = [
    'xxs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
];
export const BREAKPOINTS = {
    xxs: 0,
    xs: 360,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280,
    xxl: 1600,
}

const breakpoints = createBreakpoints({
    keys: KEYS,
    values: BREAKPOINTS,
});


const theme = createMuiTheme({
    breakpoints: breakpoints,
    overrides: {
        MuiInputLabel: {
            root: {
                fontSize: 12
            }
        },
        MuiInput: {
            root: {
                fontSize: 14
            }
        },
        MuiFormControl: {
            root: {
                marginTop: 14
            }
        },

        '@global': {
            "*": {
                WebkitFontSmoothing: 'auto',
            },
        },

    },

    palette: {

        primary: {
            light: "#FFFFFF",
            main: "#FFFFFF",
            dark: "#FFFFFF",
            contrastText: "#000",
        },
        secondary: {
            light: "#FFEAEE",
            main: "#F81004",
            dark: "#F81004",
            contrastText: "#fff",
        },
        success: {
            light: "#9df971",
            main: "#69C540",
            dark: "#329402",
        },
        text: {
            primary: "#fff",
            secondary: "#19134f",
            disabled: "#ddd",
            muted: "#666666",
            systemWash: "#ECECEC",
            hint: "rgba(0, 0, 0, 0.38)",
        },
        background: {
            default: "#202020"
        },

        ascents: {
            primary: '#FFFFFF',
            orange: '#F81004',
            secondary: '#F81004',
            danger: '#ff5b5b',
            textDark: "#333333",
            textLightDark: "#555555",
            textGrey: "#aaaaaa",

            // new
            baseDark: '#1a1a1a',
            background: "#202020",
            textLight: "#dddddd",
            green: "#34A853",
            black: '#000000',
            wash: '#eaeaea',
            grey: '#777777',
            white: '#FFFFFF',
            trans: "transparent",
        },

    },
    typography: {
        fontFamily: '"Montserrat", sans-serif',

        h1: {
            fontFamily: '"Montserrat", sans-serif',
            fontSize: 48,
            fontWeight: 600,

            [breakpoints.between(breakpoints.values.xxs, breakpoints.values.sm)]: {
                fontSize: "1.5rem",
            },

        },
        h2: {
            fontFamily: '"Playfair Display", sans-serif',
            fontSize: 25,
        },
        h3: {
            fontFamily: '"Montserrat", sans-serif',
            fontSize: 48,
            fontWeight: 600,

            [breakpoints.between(breakpoints.values.xxs, breakpoints.values.sm)]: {
                fontSize: "1.5rem",
            },
        },
        h4: {

            fontFamily: '"Playfair Display", sans-serif',
            fontSize: 18,
        },
        h5: {
            fontFamily: '"Playfair Display", sans-serif',
            fontSize: 18,
        },
        h6: {
            fontFamily: '"Playfair Display", sans-serif',
            fontSize: 18,
            fontWeight: 400,
        },
        body1: {
            fontFamily: '"Montserrat", sans-serif',
            fontSize: 14,
        },
        body2: {
            fontFamily: '"Montserrat", sans-serif',
            fontSize: 12,
        },
        body3: {
            fontFamily: '"Montserrat", sans-serif',
            textTransform: "capitalize",
            fontSize: 18,
            fontWeight: 600,
        },
        thead: {
            fontFamily: '"Playfair Display", sans-serif',

        }
    },

});

export default theme;